export class MaskEmail {
    public static mask(email: string): string {
        const emailRegex = /(^[^@]{1})[^@]*@([^\.]{1})[^\.]*/g;
        return email.replace(emailRegex, "$1****@$2****");
    }
}
